import { IBaseCellsProps } from '../cells.interfaces';
import { StyledTableCell } from './CellPerson.styles';
import { Avatar, Box, Typography, useTheme } from '../../../base-components';
import { EMPTY_CELL, isValidString } from '../../../../common';

interface Props extends IBaseCellsProps {
    data: { icon: string; name: string };
}
const CellPerson = (props: Props) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
        data,
    } = props;
    const theme = useTheme();

    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
        >
            {isValidString(data.name) ? (
                <Box display="flex" alignItems="center">
                    <Avatar
                        name={data.name}
                        src={data.icon}
                        sx={{
                            width: 30,
                            height: 30,
                            backgroundColor: theme.palette.grey[300],
                            fontSize: 14,
                        }}
                    />
                    <Typography variant={'body2'} paddingInlineStart={1}>
                        {data?.name}
                    </Typography>
                </Box>
            ) : (
                <Typography variant={'body2'}>{EMPTY_CELL}</Typography>
            )}
        </StyledTableCell>
    );
};

export default CellPerson;
